<template>
    <CModal
        title="Pengajuan Pembatalan RPL"
        :show.sync="modalDetailPembatalan"
        :no-close-on-backdrop="true"
        :centered="true"
    >
        <template #header>
            <h6 class="modal-title h5 font-weight-bold">Detail Pembatalan</h6>
        </template>
        <CRow>
            <div class="modal-body row my-n3">
                <div class="col-5">
                    <p class="font-weight-bold">Nama Anggota</p>
                    <p class="font-weight-bold">Nama RPL</p>
                    <p class="font-weight-bold">Kategori Anggota</p>
                    <p class="font-weight-bold">No. Handphone</p>
                    <p class="font-weight-bold">No. Telepon</p>
                    <p class="font-weight-bold">Email</p>
                    <p class="font-weight-bold">Bank</p>
                    <p class="font-weight-bold">Nama Rekening</p>
                    <p class="font-weight-bold">No. Rekening</p>
                    <p class="font-weight-bold">Bukti Refund</p>
                    <p class="font-weight-bold">Status Approval Keuangan</p>
                    
                </div>
                <div class="col-7">
                    <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
                    <p>: {{ formData.nama_rpl ? formData.nama_rpl : ' - ' }}</p>
                    <p>: {{ formData.kategori_anggota ? formData.kategori_anggota : ' - ' }}</p>
                    <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
                    <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
                    <p>: {{ formData.email ? formData.email : ' - ' }}</p>
                    <p>: {{ formData.nama_bank ? formData.nama_bank : ' - ' }}</p>
                    <p>: {{ formData.nama_rekening ? formData.nama_rekening : ' - ' }}</p>
                    <p>: {{ formData.no_rekening ? formData.no_rekening : ' - ' }}</p>
                    <p>: <button 
                        :class="formData.file_bukti_refund === null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                        :disabled="formData.file_bukti_refund === null" 
                        @click="lihatFile(formData.file_bukti_refund)">
                        Lihat File
                        </button>
                    </p>
                    <p>: 
                        <span class="text-success font-weight-bold" v-if="formData.status_approval_keuangan == '1' ">Disetujui</span>
                        <span class="text-danger font-weight-bold" v-else-if="formData.status_approval_keuangan == '0'">Ditolak</span>
                        <span class="text-warning font-weight-bold" v-else>Menunggu</span>
                    </p>
                    
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="" class="font-weight-bold">Alasan</label>
                        <textarea  
                        class="form-control"
                            cols="30"
                            readonly
                            v-model="formData.keterangan" 
                            rows="5">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label for class="font-weight-bold">Status</label>
                        <div class="d-flex align-items-center">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadio"
                                id="aktif"
                                value="Disetujui"
                                 :disabled="formData.status_approval_keuangan == '0' ||  formData.status_approval_keuangan == null"
                                v-model="formData.statusbatal"                                
                            />
                            <label class="custom-control-label" for="aktif">Disetujui</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadio"
                                id="tidak_aktif"
                                value="Ditolak"
                                :disabled="formData.status_approval_keuangan == '0' ||  formData.status_approval_keuangan == null"
                                v-model="formData.statusbatal"                                
                            />
                            <label class="custom-control-label" for="tidak_aktif">Ditolak</label>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </CRow>
        <template #footer>        
            <CButton @click="modalDetailPembatalan = false" color="danger">Tutup</CButton>
            <CButton color="info" @click="postStatusPembatalan" :disabled="formData.status_approval_keuangan == '0' ||  formData.status_approval_keuangan == null">Simpan</CButton>            
        </template>
    </CModal>
</template>

<script>
import Utils from "@/services/utils.service";

export default {
    name: 'modal-pengajuan-pembatalan-rpl',
    props: [
        'modalDetailPembatalan',
        'title',
        'formData'
    ],

    watch: {
        modalDetailPembatalan: function(val) {
            if(!this.modalDetailPembatalan) {                
                this.$emit('closeModalPembatalan', val)
            }            
        },        
    },

    methods: {
        postStatusPembatalan() {
            this.$parent.postStatusPembatalan(this.formData);
        },
        lihatFile(item) {
            let user = JSON.parse(localStorage.getItem('user'));
            let token = user.accessToken
            let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
        width=0,height=0,left=-1000,top=-1000`;
            window.open(
                Utils.baseurlFoUsers() + "/lihat-file/"+item+"/lokasi/file_refund/bearer/" + token,
                item.file,
                params
            );
        },
    },

    computed: {
        statusPembatalan: function() {
            if(this.formData.statusbatal === "Disetujui") {
                return 1;
            } else if(this.formData.statusbatal === "Ditolak") {
                return 2;
            } else {
                return 0;
            }
        }
    }
}
</script>

<style>

</style>